import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {NetworkInterface} from "@catmodels/network-interfaces/types";
import {isNullOrUndefined} from "util";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {StyleType} from "@catui/types";
import {GenericResourceService} from "@catfeatures/services/generic-resource.service";
import {ActiveModal} from "@catmodules/widgets/slide-in-modal/utils/modal-ref";
import {NotificationsService} from "@catcore/services";
import {NetworkInterfaceService} from "@catmodels/network-interfaces/services/network-interface.service";
import {FeatureNetworkInterfaceService} from "@catmodels/network-interfaces/services/feature-network-interface.service";
import {GgwProfile} from "@catmodels/ggw-profiles/types";
import {EntitySchemaType} from "@catcore/utils/json-schema/entity-schema-to-json-schema";
import {buildFormControlsFromSchema} from "@catuiform/shared/form-builder";
import {EntitySchemaService} from "@catcore/services/entity-schema.service";
import {GgwProfilePolicyService} from "@catmodels/ggw-profiles/services/ggw-profile-policy.service";

@Component({
  selector: 'catapp-modify-ggw-profile',
  templateUrl: './modify-ggw-profile.component.html',
  styleUrls: ['./modify-ggw-profile.component.scss']
})
export class ModifyGgwProfileComponent implements OnInit {

  private _ggwProfile: GgwProfile;

  @Input() project = null;

  @Output() afterDelete = new EventEmitter();
  @Output() afterUpdate = new EventEmitter<GgwProfile>();
  @Output() afterCreate = new EventEmitter<GgwProfile>();

  @Input()
  get ggwProfile(): GgwProfile {
    return this._ggwProfile;
  }

  set ggwProfile(value: GgwProfile) {
    this._ggwProfile = value;
    if (!isNullOrUndefined(this._ggwProfile)) {
      this.form.patchValue(this._ggwProfile);
    }
  }

  labels = {
    name: 'Name',
    unit: 'Control Unit',
    default_policy: 'Default Policy',
    type: 'Type',
    aircraft_schematic_url: 'Aircraft Schematic Url',
    show_in_profile_list: 'Show in Profile List',
    show_connected_clients: 'Show Connected Clients',
  };

  typeOptionsStatic = [
    {value: 'Crew', label: 'Crew'},
    {value: 'PED', label: 'PED'},
    {value: 'Default', label: 'Default'},
    {value: 'Other', label: 'Other'},
  ];

  policyOptions = [
    {value: 'allow', label: 'Allow'},
    {value: 'deny', label: 'Deny'},
  ];

  unitUri: string;

  form: FormGroup;
  styleType = StyleType;

  private readonly modelSchema;

  constructor(private formBuilder: FormBuilder,
              private resourceService: GenericResourceService,
              private activeModal: ActiveModal,
              private notification: NotificationsService,
              schemaService: EntitySchemaService) {
    this.modelSchema = schemaService.getForEntityName(EntitySchemaType['GgwProfiles']);
    const formControls = buildFormControlsFromSchema(this.formBuilder, this.modelSchema);
    this.form = this.formBuilder.group(formControls);
  }

  ngOnInit() {
  }

  get dataIsReady() {
    return !isNullOrUndefined(this._ggwProfile);
  }

  hasControlUnit() {
    return this._ggwProfile && this._ggwProfile._links && this._ggwProfile._links.unit;
  }

  saveProfile() {
    const formValue = this.form.value;
    formValue['project'] = this.project._links.self.href;
    delete formValue['unit'];
    const create = (formValue.id === null);
    const service = this.resourceService.findServiceForResource(create
      ? this.modelSchema.resourceUri
      : this._ggwProfile._links.self.href);

    const subscr = service
      .save(this.form.value, create)
      .finally(() => subscr.unsubscribe())
      .subscribe((res) => {
        this.notification.success('Update successful', 'GGW Access Profile has been saved.');
        this.activeModal.close();
        if (create) {
          this.afterCreate.emit(res);
        } else {
          this.afterUpdate.emit(res);
        }
      });
  }

  deleteProfile() {
    const confirmDelete = confirm('Are you sure you want to delete this ggw profile?');
    if (confirmDelete) {
      const service = this.resourceService.findServiceForResource(this._ggwProfile._links.self.href);
      service
        .delete()
        .subscribe(() => {
          this.notification.success('GGW Access Profile deleted', 'The ggw access profile was successfully removed.');
          this.afterDelete.emit();
          this.activeModal.close();
        });
    }
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/ggw-profiles/components/modify-ggw-profile/modify-ggw-profile.component.ts